import React, {useContext} from "react";
import {RecordsManagementContext} from "../StatesMangement/InitialiseContext";
import "@creative-fonts/agreement-signature"

export default () => { // This component Shows the Moving consultants
    let RecordsController = useContext(RecordsManagementContext)
    let records = RecordsController.CP_PageDetails.MovingConsultant
    let booked_by_component = RecordsController.IsJobBooked ? <MovingConsultantSubComponent
        BookedBy={records.BookedBy} BookedOn={records.BookedOn}/> : ''
    if (!RecordsController.IsJobOpen) { // If "Job Is Open And Not 100%" then it will not display.
        return (
            <div className="contact-information mb-4">
                <ul className="contact-info-list pl-0 mb-0">
                    <li><h6>{records.Verbiage}</h6></li>
                    <MovingConsultantSubComponent EstimatedBy={records.EstimatedBy} EstimatedOn={records.EstimatedOn}/>
                    {booked_by_component} {/*Booked By Moving consultants only shows if 'Job is Booked'*/}
                </ul>
            </div>
        )
    } else {
        return (<></>)
    }
};

const MovingConsultantSubComponent = (props) => {
    let EstimatedOn = props.EstimatedOn
    let BookedOn = props.BookedOn
    let EmployeeData = props.EstimatedBy || props.BookedBy
    return(
        <li>
            <div className="row">
                <div className="col-7">
                    <div className="estimated-by">
                        <span>{EstimatedOn !== undefined ? 'Estimated By' : 'Booked By'}...</span>
                        <h5>{EmployeeData.Name}</h5>
                        <span>{EmployeeData.Mail}</span>
                        <span>{EstimatedOn !== undefined ? 'Estimated On: '+EstimatedOn : 'Booked On: '+BookedOn }</span>
                    </div>
                </div>
                <div className="col-5">
                    <div className="estimated-user">
                        <img  src={EmployeeData.ProfilePic} alt="Employee Profile"/>
                    </div>
                </div>
            </div>
            <div className="signature-img text-left">
                {EmployeeData.SuperUserPresent ?
                    <div style={{fontSize:" 40px",fontFamily:"Agreement Signature",paddingTop:"2px"}}>
                        {EmployeeData.SignaturePic}
                    </div>
                    :
                    <img  src={EmployeeData.SignaturePic} alt="Employee Sign"/>
                }

            </div>
        </li>
    );
}